<template>
  <section class="sure-info"
           v-show="isShow">
    <div class="border-out-box">
      <img src="../assets/img/noAccess/close.png"
           @click="cancel" />
      <p> {{ title }} </p>
      <div class="content-box"> {{ content }} </div>
      <div>
        <div class="btn-box">
          <slot></slot>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      default () {
        return false
      }
    },
    title: {
      type: String,
      default () {
        return '提示'
      }
    },
    content: {
      type: String,
      default () {
        return ''
      }
    }
  },
  name: 'sure-info',
  data () {
    return {
      // isShow: false


    }
  },
  methods: {
    cancel () {
      this.$emit('isShow', false);
      // this.isShow = false
    }
  }

}
</script>
<style lang="scss" scoped>
@import "@/assets/css/color.scss";
.sure-info {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.3);
  .border-out-box {
    margin: 400px auto 0;
    width: 60%;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 10px;
    font-size: 28px;
    text-align: right;
    padding: 31px;
    img {
      width: 48px;
      height: 48px;
    }
    p {
      font-size: 30px;
      font-family: 宋体;
      font-weight: 500;
      color: #282b29;
      // border-bottom: 1px solid #ccc;
      padding: 0px 24px 24px 24px;
      text-align: center;
      margin-top: -20px;
    }
    .content-box {
      padding: 0px 63px;
      font-size: 26px;
      font-family: 宋体;
      font-weight: 400;
      color: #8f98a8;
      text-align: left;
    }
    .btn-box {
      display: flex;
      justify-content: center;

      div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        input {
          width: 340px;
          height: 72px;
          line-height: 72px;
          border-radius: 16px 16px 16px 16px;
          border: 1px solid #dcdcdc;
          text-align: left;
          padding-left: 20px;
          font-size: 28px !important;
        }
        span {
          width: 100%;
          font-size: 22px;
          font-weight: 400;
          color: #f24a37;
          margin-top: 8px;
        }
        .sure-btn {
          width: 240px;
          height: 80px;
          background: #4a8ef7;
          box-shadow: 0px 6px 20px 1px rgba(63, 138, 247, 0.2);
          border-radius: 49px 49px 49px 49px;
          font-size: 32px;
          font-weight: 400;
          color: #ffffff;
          text-align: center;
          margin-top: 32px;
        }
      }
    }
  }
}
</style>
